import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './assets/common.less'

ReactDOM.render(<App />, document.getElementById('app'))
